export const OPEN = '@guide/open';
export const CLOSE = '@guide/close';
export const SET_INDEX_NODE = '@guide/set-index-node';
export const SET_VIEW = '@guide/set-view';
export const UNSET_NODE = '@guide/unset-node';
export const OPEN_NODE = '@guide/open-node';
export const SUBMIT_FEEDBACK = '@guide/feedback-submit';
